import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutUsComponent } from './about-us/about-us.component';
import { LandingComponent } from './landing/landing.component';
import { TechnologyComponent } from './technology/technology.component';
import { CompanyComponent } from './company.component';
import { RouterModule, Routes } from '@angular/router';
import { FooterModule, HeaderModule, AnimationModule } from '@shared/components';
import { TranslateModule } from '@ngx-translate/core';
import { GcgComponent } from './gcg/gcg.component';
import { ManagementComponent } from './management/management.component';
import { FinancialReportComponent } from './financial-report/financial-report.component';

const routes: Routes = [
  {
    path: '',
    component: CompanyComponent,
  },
  {
    path: ':id',
    component: CompanyComponent,
  }
];

@NgModule({
  declarations: [
    CompanyComponent,
    AboutUsComponent, 
    LandingComponent, 
    TechnologyComponent,
    GcgComponent,
    ManagementComponent,
    FinancialReportComponent
  ],
  imports: [
    CommonModule,
    HeaderModule,
    FooterModule,
    RouterModule.forChild(routes),
    AnimationModule,
    TranslateModule
  ]
})
export class CompanyModule { }
